import { render, staticRenderFns } from "./EditAdministrator.vue?vue&type=template&id=064b37e8"
import script from "./EditAdministrator.vue?vue&type=script&lang=js"
export * from "./EditAdministrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports